module.exports = __webpack_public_path__ + "static/media/pipping.504d212b.jpg";